import { Box } from '@mui/system'

const BookingSummaryEntry = ({ Icon, title, value }) => {
  return (
    <Box
      component="div"
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 'var(--sp-4, 16px)',
        marginBottom: 'var(--sp-1, 4px)',
        minHeight: '40px',
      }}
    >
      <Box component="div" sx={{ minWidth: '36px', display: 'flex' }}>
        {Icon && (
          <Box
            component="div"
            sx={(theme) => ({
              alignItems: 'center',
              background: value
                ? theme.components.bookingSummary.iconFillComplete
                : 'transparent',
              border: 'solid',
              borderColor: value
                ? theme.components.bookingSummary.iconLineComplete
                : theme.components.bookingSummary.iconLinePending,
              borderWidth: '1px',
              color: value
                ? theme.components.bookingSummary.iconLineComplete
                : theme.components.bookingSummary.iconLinePending,
              boxSizing: 'border-box',
              display: 'flex',
              flexShrink: 0,
              height: '36px',
              justifyContent: 'center',
              borderRadius: '50%',
              lineHeight: 0,
              width: '36px',
            })}
          >
            <Icon sx={{ display: 'block', fontSize: '20px' }} />
          </Box>
        )}
      </Box>
      <Box
        component="div"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          alignItems: 'flex-start',
        }}
      >
        <Box
          component={'p'}
          sx={(theme) => ({
            textTransform: 'uppercase',
            color: theme.components.bookingSummary.sectionTitle,
            fontSize: 'var(--fs-12, 0.75rem)',
            letterSpacing: 'var(--tracking-caps, 0.14em)',
            fontWeight: 600,
            marginBottom: '0',
          })}
        >
          {title}
        </Box>
        <Box
          component={'div'}
          sx={(theme) => ({
            fontSize: 'var(--fs-14, 0.875rem)',
            color: value
              ? theme.components.bookingSummary.sectionAnswerComplete
              : theme.components.bookingSummary.sectionAnswerPending,
            fontFamily: 'var(--font-sans, "Inter", sans-serif)',
            fontWeight: 400,
            marginTop: '0',
            '& p': {
              margin: 0,
            },
          })}
        >
          {value || 'Information required'}
        </Box>
      </Box>
    </Box>
  )
}

export default BookingSummaryEntry
